import { LucideIcon } from 'lucide-react';
import VenereCalendar from '../../shared/ui/icons/VenereCalendar';
import VenereDoctor from '../../shared/ui/icons/VenereDoctor';
import VenereHeart from '../../shared/ui/icons/VenereHeart';
import VenereWeight from '../../shared/ui/icons/VenereWeight';
import { QuickAction } from '../types/QuickAction';

export interface QuickActionConfig {
  title: string;
  comment: string;
  buttonText: string;
  icon: LucideIcon | React.ComponentType<{ size?: number; color?: string }>;
  redirect: string;
}

export const QUICK_ACTION_CONFIG: Record<QuickAction, QuickActionConfig> = {
  [QuickAction.AddMeal]: {
    title: 'Aggiungi pasti',
    comment: 'Cosa hai mangiato oggi?',
    buttonText: 'Aggiungi ora',
    icon: VenereHeart,
    redirect: '/venere/add-meal',
  },
  [QuickAction.SaveWeight]: {
    title: 'Registra peso',
    comment: 'Aggiorna i tuoi progressi',
    buttonText: 'Registra ora',
    icon: VenereWeight,
    redirect: '/venere/register-weight',
  },
  [QuickAction.NextInjection]: {
    title: 'Prossima iniezione',
    comment: 'Mancano 5 giorni',
    buttonText: 'Vai al tutorial',
    icon: VenereDoctor,
    redirect: '/venere/next-injection',
  },
  [QuickAction.BookConsult]: {
    title: 'Prenota controllo',
    comment: 'Prenota con il medico',
    buttonText: 'Prenota ora',
    icon: VenereCalendar,
    redirect: '/venere/book-consult',
  },
};

/**
 * Helper function to get quick action configuration
 */
export const getQuickActionConfig = (action: QuickAction): QuickActionConfig => {
  return QUICK_ACTION_CONFIG[action];
};

/**
 * Helper function to get just the icon for a quick action
 */
export const getQuickActionIcon = (action: QuickAction) => {
  return QUICK_ACTION_CONFIG[action].icon;
};
